function getTeaserOrientation(currentOrientation) {
  return (currentOrientation === 'right' ? 'left' : 'right');
}

export default getTeaserOrientation;
